import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import dayjs from "dayjs";
import { LANDING_FALLBACK, LANDING_SETTINGS } from "../constants/Landing";

/**
 * Check if today is within landing date range
 * @param {dayjs.Dayjs} todayDate
 * @param {import("../constants/Landing").LANDING_SETTINGS} landing
 * @returns {boolean}
 */
function isWithinLanding(todayDate, landing) {
  const year = todayDate.year();
  const start = dayjs()
    .year(year)
    .month(landing.start_month - 1)
    .date(landing.start_day)
    .startOf("day");
  const end = dayjs()
    .year(year)
    .month(landing.end_month - 1)
    .date(landing.end_day)
    .endOf("day");

  // Inclusive range, handling periods that wrap year-end
  return end.isBefore(start)
    ? !todayDate.isBefore(start) || !todayDate.isAfter(end)
    : !todayDate.isBefore(start) && !todayDate.isAfter(end);
}

/**
 * @typedef {Object} Props
 * @property {boolean} isDesktop
 */
/**
 * Get landing image path
 * @param {Props} props
 * @returns {string}
 */
export function getLandingImage({ isDesktop }) {
  const todayDate = dayjs();
  const matched = LANDING_SETTINGS.find((landing) =>
    isWithinLanding(todayDate, landing),
  );
  const filePath = matched
    ? isDesktop
      ? matched.path_video
      : matched.path
    : LANDING_FALLBACK;

  return generateFrontPath({
    id: "@front.internal-assets",
    parameters: { filePath },
    includeBasePath: true,
  });
}
